import { graphql } from 'react-relay/hooks'
import { useMutation } from 'hooks'

const mutation = graphql`
  mutation useReportResolutionUpdateStatusMutation(
    $input: UpdateResolutionStatusInput!
    $resolutionSection: String
    $anomalies: [String]
  ) {
    updateResolutionStatus(input: $input) {
      reportResolution {
        id
        currentValue
        initialValue
        resolutionKind
        status
        updateStatus
        anomalyTypes
        report {
          reviewStatus
          resolutionProgress
          ...ReportResolution_report
          ...ReportResolutionTable_report
        }
      }
    }
  }
`

export default function useResolutionUpdateStatus() {
  return useMutation(mutation, 'updateResolutionStatus')
}
